import './SyncHealthNotification.scss';

export { default } from './SyncHealthNotification';
